import { Animation, createAnimation } from '@ionic/core';

export const alertModalAndroidLeaveAnimation = (baseEl: HTMLElement): Animation => {
  if (!baseEl) {
    return createAnimation();
  }

  const baseAnimation = createAnimation();
  const backdropAnimation = createAnimation();
  const modalContentAnimation = createAnimation();

  const backdropEl = baseEl.querySelector('ion-backdrop');
  if (backdropEl) {
    backdropAnimation.addElement(backdropEl).fromTo('opacity', 'var(--backdrop-opacity)', 0);
  }

  const contentEl = baseEl.querySelector('.modal-content');
  if (contentEl) {
    modalContentAnimation.addElement(contentEl).keyframes([
      { offset: 0, opacity: 0.99, transform: 'translateY(0px)' },
      { offset: 1, opacity: 0, transform: 'translateY(40px)' },
    ]);
  }

  return baseAnimation
    .addElement(baseEl)
    .easing('cubic-bezier(0.47,0,0.745,0.715)')
    .duration(200)
    .addAnimation([backdropAnimation, modalContentAnimation]);
};
